import React from 'react';
import { Project } from '../../shared/models/Project';
import { MemberIcon, MoneyIcon } from './StatIcons';
import './ProjectList.css';

interface ProjectListProps {
  projects: Project[];
  loading?: boolean;
  emptyText?: string;
  onItemClick?: (project: Project) => void;
}

const formatAmount = (amount: number) => {
  if (amount >= 10000) return `${(amount / 10000).toFixed(1)}万`;
  return amount.toLocaleString('zh-CN', { minimumFractionDigits: 0 });
};

export const ProjectList: React.FC<ProjectListProps> = ({
  projects,
  loading = false,
  emptyText = '暂无项目',
  onItemClick,
}) => {
  const placeholder = '/placeholder.svg';
  if (loading) {
    return <div className="pl-project-loading">加载中...</div>;
  }

  if (!projects || projects.length === 0) {
    return (
      <div className="pl-project-empty">
        <img src="/opening.svg" alt="暂无项目" className="pl-empty-image" />
        <div className="pl-empty-text">{emptyText}</div>
      </div>
    );
  }

  return (
    <div className="pl-project-list">
      {projects.map((project) => (
        <div
          key={project.id}
          className={`pl-project-card ${project.status === 'STOPPED' ? 'pl-stopped' : ''}`}
          onClick={() => onItemClick?.(project)}
        >
          <div className="pl-project-image">
            {project.status === 'STOPPED' && <span className="pl-status-tag">已停售</span>}
            <img
              src={project.coverThumbUrl || project.coverImageUrl || placeholder}
              alt={project.title}
              loading="lazy"
              onError={(e) => {
                e.currentTarget.src = placeholder;
              }}
            />
          </div>
          <div className="pl-project-content-wrapper">
            <div className="pl-project-content">
              <h3 className="pl-project-title">{project.title || '未命名项目'}</h3>
              <p className="pl-project-description">{project.description || '暂无描述'}</p>
            </div>
            <div className="pl-project-stats">
              <div className="pl-stat-item">
                <span className="pl-stat-icon">
                  <MemberIcon />
                </span>
                <span className="pl-stat-value">{project.participantCount || 0}</span>
              </div>
              <div className="pl-stat-item">
                <span className="pl-stat-icon">
                  <MoneyIcon />
                </span>
                <span className="pl-stat-value">{formatAmount(project.raisedAmount || 0)}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};


